import { render, staticRenderFns } from "./MoleculeSupportModal.vue?vue&type=template&id=040cd6af&"
import script from "./MoleculeSupportModal.vue?vue&type=script&lang=js&"
export * from "./MoleculeSupportModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports